// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2de8ba02","453":"e2f28b28","455":"ec0b018d","703":"591413b8","977":"2005531b"}[chunkId] + ".chunk.js";
};